import type { z as ZodType } from 'zod';

export function lazyZodSchema<T extends ZodType.ZodTypeAny>(factory: (z: typeof ZodType) => T): T {
  let instance: any;
  return new Proxy({} as any, {
    get(_target, prop) {
      // Allow inspection and promise checks without triggering lazy load or throwing
      if (typeof prop === 'symbol' || prop === 'then' || prop === 'inspect' || prop === 'asymmetricMatch') {
        if (!instance) return undefined;
      }

      if (!instance) {
        let zMod: any;
        try {
          // eslint-disable-next-line @typescript-eslint/no-var-requires
          zMod = require('zod');
        } catch {
          throw new Error(
            'Zod is required to access this schema, but it is not installed in this environment.'
          );
        }

        const z = (typeof zMod?.string === 'function')
          ? zMod
          : (typeof zMod?.z?.string === 'function')
            ? zMod.z
            : (typeof zMod?.default?.string === 'function')
              ? zMod.default
              : (typeof zMod?.default?.z?.string === 'function')
                ? zMod.default.z
                : (zMod?.z || zMod?.default || zMod);
        instance = factory(z);
      }
      const val = instance[prop];
      return typeof val === 'function' ? val.bind(instance) : val;
    }
  });
}
